// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___wvkWz";
var _2 = "styles-module__logo___XxeNY";
var _3 = "styles-module__membersIconsContainer___B8YJK";
var _4 = "styles-module__title___FGviG";
export { _1 as "container", _2 as "logo", _3 as "membersIconsContainer", _4 as "title" }
